import React from 'react';
import { Link } from 'react-router-dom';
const hStyle = { color: 'blue' };

const Submission = ()=> (
    <div>
        <h2>Paper Submission</h2>
        <p style={hStyle}> The paper submission deadline is now extended to <b>November 24, 2021</b>.</p>
        <p>Paper submission will be handled via the CMT system. Please submit your paper at <a href="https://cmt3.research.microsoft.com/DSLW2022" target="_blank">https://cmt3.research.microsoft.com/DSLW2022</a></p>
        <p>Submissions can be edited until the deadline. Please see <Link to="/deadlines">deadline dates</Link> on the website for further details on the schedule.</p>
        <p>For the paper submission process, please see the <a href={process.env.PUBLIC_URL + '/CMT_instructions.pdf'} target="_blank">CMT instructions for authors</a> file for detail instructions on how to navigate the CMT submission site.</p>
    </div>
);

export default Submission;